import { nanoid } from "nanoid";
/*import FingerprintJS from "@fingerprintjs/fingerprintjs";

const fingerPrintSaver = async () => {
  try {
    const fp = await FingerprintJS.load();

    const result = await fp.get();

    const visitorId = result.visitorId;

    window.localStorage.setItem("fingerPrint", visitorId);
  } catch (e) {
    alert(`Ошибка FingerPrint ${e}`)
  }
};*/

const fingerPrintSaver = () => {
  window.localStorage.setItem("fingerPrint", nanoid());
}

export default fingerPrintSaver;
